// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607130852/js/" + chunkId + "." + {"44":"8363f04e","225":"cb69e982","481":"1413dbdf","486":"0dbb9656","770":"69db263f"}[chunkId] + ".0.7011183138344044.chunk.js";
};